module.exports = __webpack_public_path__ + "static/img/222.9377498.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/222.png
// module id = R2TG
// module chunks = 0